import { requestAsync, httpMethods, UPDATE_DEFAULT } from '../requery/actions';
import auth from '../auth';
import {
    ADD_DEFAULT_COMMON_DICTIONARY,
    CHANGE_I18_TABLE_ITEM,
    LOAD_COMMON_DICTIONARY,
    SELECT_SECONDARY_LANG,
} from './constants';

export const toIdArray = ar => ar.reduce((acc, el) => (el ? acc.concat(el) : acc), []);

export const addDefaultCommonDictionary = commonDictionaryEn => ({
    type: ADD_DEFAULT_COMMON_DICTIONARY,
    payload: { commonDictionaryEn },
});

export const loadDictionary = commonDictionaryEn => {
    const user = auth.getUser();

    return requestAsync({
        url: `/api/i18/${user.client}/${user.username}/common?access_token=${auth.getAccessToken()}`,
        update: {
            i18: UPDATE_DEFAULT.MERGE,
        },
        transform: i18 => ({ i18 }),
        list: body => ({
            i18: () => Object.keys(body),
        }),
        queryKey: 'GET:i18',
        options: {
            method: httpMethods.GET,
        },
        nextAction: () => addDefaultCommonDictionary(commonDictionaryEn),
    });
};

export const loadCommonDictionary = (i18 = {}) => {
    return {
        type: LOAD_COMMON_DICTIONARY,
        payload: { i18 },
    };
};

export const saveTranslations = i18 => {
    const user = auth.getUser();

    return requestAsync({
        url: `/api/i18/${user.client}/${user.username}/common?access_token=${auth.getAccessToken()}`,
        body: i18,
        update: {
            i18: UPDATE_DEFAULT.MERGE,
        },
        transform: i18 => ({ i18 }),
        list: body => ({
            i18: () => Object.keys(body),
        }),
        queryKey: 'PUT:i18',
        options: {
            method: httpMethods.PUT,
            headers: {
                'Content-Type': 'application/json',
            },
        },
    });
};

export const saveWidgetTranslations = (widgetId, i18 = {}) => {
    const user = auth.getUser();

    if (!widgetId) {
        return {
            type: 'error',
        };
    }

    return requestAsync({
        url: `/api/i18/${user.client}/${user.username}?${
            widgetId ? `widgetId=${widgetId}` : ``
        }&access_token=${auth.getAccessToken()}`,
        body: { [widgetId]: i18 },
        update: {
            i18Widget: UPDATE_DEFAULT.LATEST,
        },
        transform: i18Widget => ({ i18Widget }),
        list: body => ({
            i18Widget: () => Object.keys(body),
        }),
        queryKey: 'PUT:i18Widget',
        options: {
            method: httpMethods.PUT,
            headers: {
                'Content-Type': 'application/json',
            },
        },
    });
};

export function changeI18TableItem(lang, label, value) {
    return {
        type: CHANGE_I18_TABLE_ITEM,
        payload: { lang, label, value },
    };
}

export function selectSecondaryLang(lang) {
    return {
        type: SELECT_SECONDARY_LANG,
        payload: { lang },
    };
}



/** WEBPACK FOOTER **
 ** ../src/dash/front/common-i18-dashboard-page/actions.js
 **/